// tslint:disable file-name-casing
import 'custom-event-polyfill';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Provider as ReduxQueryProvider } from 'redux-query-react';
import configureStore from './helpers/reduxStore';
import LocaleRouter from './routers/LocaleRouter';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { MsalProvider } from '@azure/msal-react';

const msalInstance = new PublicClientApplication(msalConfig);
const rootEl = document.getElementById('root');
export const store = configureStore();

if (document.documentElement) {
    document.documentElement.classList.remove('is-loading');
}

ReactDOM.render(
    (
        <MsalProvider instance={msalInstance}>
            <Provider store={store}>
                <ReduxQueryProvider queriesSelector={(state => state.queries)}>
                    <BrowserRouter>
                        <LocaleRouter/>
                    </BrowserRouter>
                </ReduxQueryProvider>
            </Provider>
        </MsalProvider>
    ),
    rootEl
);
